export const useEnvPropsStore = defineStore('envProps', {
  state: () => ({
    googleCaptchaSiteKey: null,
    ogAuthBase: null,
    autoReplenishFaq: null,
    tokenizationIframeSource: null,
    tokenizationPciIframeSrc: null,
    deviceType: null,
    nuxtAppCDNUrl: null,
    tagManagerEnv: null,
    googleEnterpriseRecaptchaSiteKey: '',
    killSwitches: null,
  }),
});
